import { isUnifiedCommerce } from '@shared/constants'

export default {
  install() {
    /**
     * Unzer merchants have signed contracts with Unzer, which allow us to not ask for consents inside the application.
     */
    if (isUnifiedCommerce()) {
      return
    }

    const url = '//cdn.cookie-script.com/s/a895bc34a48888cee5d82a82ca1c48fe.js'
    const scriptNode = document.createElement('script')
    scriptNode.setAttribute('src', url)
    document.body.appendChild(scriptNode)
  }
}
